import React, { useId } from "react";
import { Form } from "react-bootstrap";
import { __ } from "services/Translator";

/**
 * "Show unavailable games" switch (GCC sorting redesign, Phase 4).
 *
 * The HOST decides whether this renders at all: it must be gated on
 * hasUnavailableGames(rawList) computed from the UNFILTERED list. Gating on the
 * filtered list would make the switch vanish the moment a player turns it off,
 * trapping them with no way back — and today (backend flag OFF, no `available`
 * field) the gate is always false, which is what keeps Phase 4 a visual no-op.
 */
export default function ShowUnavailableToggle({ id, checked, onChange }) {
  // A hardcoded id would let a second toggle on the same page steal the first
  // one's <label htmlFor>. useId is per-instance; the colons it contains are
  // legal in an id attribute but break querySelector/CSS, so they are stripped.
  const instanceId = useId().replace(/:/g, "");
  const controlId = id || `showUnavailableGamesToggle-${instanceId}`;

  return (
    <Form.Check
      type="switch"
      role="switch"
      id={controlId}
      className="showUnavailableToggle"
      label={__("Show unavailable games")}
      checked={!!checked}
      onChange={(e) => onChange && onChange(e.target.checked)}
    />
  );
}
